import { CloudSun, EyeOff, Eye } from "lucide-react";
import { fmt } from "@/lib/catalog";
import { sunNoonWinter } from "@/lib/geo";

import { tr } from "@/lib/i18n";
// Ombre degli ostacoli: evidenzia i moduli in ombra, l'utente decide se toglierli
export const ShadowPanel = ({ p, ed, layout, commit }) => {
  const shaded = layout.active.filter((c) => c.shaded);
  const withH = (p.roofs || []).some((r) => (r.obstacles || []).some((o) => Number(o.height) > 0));
  const removeShaded = () => commit((prev) => ({
    roofs: prev.roofs.map((r) => {
      const ks = shaded.filter((c) => c.fid === r.id).map((c) => c.key);
      return ks.length ? { ...r, removed: [...new Set([...(r.removed || []), ...ks])] } : r;
    }),
  }));
  return (
    <div className="space-y-2 text-xs" data-testid="editor-shadows">
      <div className="flex items-center justify-between">
        <span className="text-slate-500 flex items-center gap-1.5"><CloudSun className="w-4 h-4 text-amber-600" />{tr("Sole 21 dic, 12:00 ·")} {fmt(sunNoonWinter(p.lat), 1)}°</span>
        <button data-testid="editor-toggle-shadows" onClick={() => ed.toggle("showShadows")} title={ed.showShadows ? tr("Nascondi ombre") : tr("Mostra ombre")}
          className="w-8 h-8 grid place-items-center rounded-md border border-slate-200 text-slate-500 hover:bg-slate-50">
          {ed.showShadows ? <Eye className="w-4 h-4" /> : <EyeOff className="w-4 h-4" />}
        </button>
      </div>
      {layout.fields.filter((f) => f.selfShaded).map((f) => (
        <p key={f.roof.id} className="text-amber-800 bg-amber-50 border border-amber-200 rounded p-1.5" data-testid={`editor-self-shaded-${f.roof.id}`}>
          {f.roof.name}{tr(": pendenza maggiore dell'altezza del sole, la falda è tutta in ombra propria il 21 dicembre a mezzogiorno.")}
        </p>
      ))}
      {!withH ? (
        <p className="text-slate-400">{tr("Inserisci l'altezza degli ostacoli (passo Tetto) per calcolare le ombre.")}</p>
      ) : (
        <>
          <div data-testid="editor-shaded-count">{tr("Moduli in ombra:")} <b className={shaded.length ? "text-orange-600" : ""}>{shaded.length}</b></div>
          <button data-testid="editor-remove-shaded" disabled={!shaded.length} onClick={removeShaded}
            className="w-full h-9 rounded-md border border-orange-300 text-orange-700 bg-orange-50 hover:bg-orange-100 disabled:opacity-40 disabled:cursor-not-allowed text-sm">
            {tr("Togli i moduli in ombra (")}{shaded.length})
          </button>
          <p className="text-slate-400">{tr("Bordo arancione = modulo in ombra, anche oltre colmo e displuvi sulle falde dello stesso edificio. Puoi toglierli uno per uno con la gomma.")}</p>
        </>
      )}
    </div>
  );
};
